import { ReactComponent as Star } from "../../../images/Star-full.svg"
import { Radio } from "semantic-ui-react"
import { useEffect, useState } from "react"
import { withRouter } from "react-router"
import { connect } from "react-redux"
import { updateCart } from "../../../v1/actions/user"
import { withTranslation } from "react-i18next"
import { getUpdatedCart } from "../../../v1/helpers/orderHelpers"

const ApplyRewards = ({ rewards, isSubmitting, applyRewards, toggleRedeem }) => {
  console.log(rewards)
  const points = rewards?.pendingMiles - (rewards?.pendingMiles % rewards?.milesPerDollar)

  const onToggle = (e) => {
    toggleRedeem(!applyRewards)
  }

  return (
    <div className="apply-rewards">
      <div className="apply-rewards__left">
        <div className="apply-rewards__header">
          <div className="apply-rewards__icon">
            <Star width={8} height={8} />
          </div>
          <p className="apply-rewards__title">Apply Rewards</p>
        </div>

        <p className="apply-rewards__value">
          {points?.toLocaleString()} pts = $
          {(points / rewards?.milesPerDollar ?? 100)?.toFixed(2).toLocaleString()}
        </p>

        <p className="apply-rewards__helper-text">1000 pts = $10.00</p>
      </div>

      <Radio
        toggle
        className="apply-rewards__radio"
        onChange={onToggle}
        checked={applyRewards}
        disabled={isSubmitting}
      />
    </div>
  )
}

function mapStateToProps(state, props) {
  const user = state.user
  let cart
  const braintreePaymentMethods = Array.isArray(state?.paymentMethods?.braintreePaymentMethods)
    ? state.paymentMethods.braintreePaymentMethods.filter((method) => method?.type !== "ach")
    : []
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)
  const order =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)
  let updatedCartData = getUpdatedCart(user, order, props)
  if (updatedCartData) {
    cart = updatedCartData.cart
  } else {
    cart = user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
  }

  return {
    cart: cart,
    activeVehicle: activeVehicle,
    rewards: state.rewards
  }
}

export default withRouter(
  connect(mapStateToProps, {
    updateCart
  })(withTranslation("serviceRequest")(ApplyRewards))
)
